import Vue from 'vue';
import moment from 'moment';


Vue.filter('formatDateTime', (date: Date) => moment(date).format('DD/MM/YYYY HH:mm:ss'));
Vue.filter('formatDate', (date: Date) => (date ? moment(date).format('DD/MM/YYYY') : ''));
